import { TranRecordModel } from "./tran-record.model";

export class TranDynOptModel {
    tranRecord: TranRecordModel

    constructor(
        tranRecord: TranRecordModel
    ) {
        this.tranRecord = tranRecord
    }
}